<template>
  <v-row justify="center">
    <action-loading v-if="showDialog" :is-loading="isLoading"></action-loading>
    <v-dialog
        v-if="respondent"
        v-model="showDialog"
        max-width="400"
    >
      <v-card rounded>
        <v-card-title class="text-h5 success" style="color:white;">
          <v-icon dark class="mr-3">mdi-arrow-up-bold-box-outline</v-icon>
          {{ $t('dialog.upgrade_result.title') }}
        </v-card-title>

        <v-card-text class="mt-5">
          <i18n tag="p" class="body-1 mb-0" path="dialog.upgrade_result.text">
            <strong>{{respondent.custom_data.name}}</strong>
          </i18n>
        </v-card-text>
        <v-card-text>
          <p>
            {{ $t('dialog.upgrade_result.text2') }}
          </p>
          <v-alert border="left" color="back_accent" class="mb-0">
            {{ $t('message.credit_change') }} <strong class="title">-{{result_types[2].price - result_types[1].price}}</strong>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="diagClose" text>
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
              :disabled="disableSubmitButton"
              color="success"
              text
              :loading="isLoading"
              @click="upgradeResult"
          >
            {{ $t('result.upgrade_button') }}
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </v-row>

</template>

<script>
  export default {
    name: "UpgradeResult",
    props: ['respondent', 'showDialog'],
    data() {
      return {
        disableSubmitButton: false
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters['diagnostic/isLoading']
      },
      result_types() {
        return this.$store.getters['diagnostic/result_types']
      }
    },
    methods: {
      async upgradeResult() {
        this.disableSubmitButton = true
        const payload = {uuid:this.respondent.uuid,new_type:2}
        let res = await this.$store.dispatch('diagnostic/upgradeResult',payload)
        if (res.upgraded) {
          await this.$store.dispatch('auth/onAuthChange')
          await this.$store.dispatch('notification/push', {timeout: 1500,color: 'success','text': 'výsledek byl povýšen', icon:'mdi-check'})
        } else {
          await this.$store.dispatch('notification/push', {color: 'error','text': 'došlo k neočekávané chybě [#U102]', icon:'mdi-alert'})
        }
        this.diagClose()
      },
      diagClose() {
        this.disableSubmitButton = false
        this.$emit('diagClose')
      }
    },
    created() {
    },
    watch: {
    }
  }
</script>